import { X, ArrowLeft, ArrowRight } from 'lucide-react';

export default function SetupModal({ 
  show, 
  currentStep, 
  formData, 
  setFormData, 
  momoProviders, 
  onNext, 
  onBack, 
  onCancel 
}) {
  if (!show) return null;

  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center p-4 bg-black bg-opacity-50">
      <div className="overflow-hidden mx-4 w-full max-w-md bg-white rounded-2xl shadow-2xl">
        {/* Modal Header */}
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">Setup Payment Method</h3>
          <button
            onClick={onCancel}
            className="text-gray-400 transition-colors hover:text-gray-600"
          >
            <X size={24} />
          </button>
        </div>

        {/* Progress Bar */}
        <div className="px-6 pt-4">
          <div className="flex justify-between items-center mb-4">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
              currentStep >= 1 ? 'bg-emerald-600 text-white' : 'bg-gray-200 text-gray-600'
            }`}>
              1
            </div>
            <div className={`flex-1 h-1 mx-2 ${
              currentStep >= 2 ? 'bg-emerald-600' : 'bg-gray-200'
            }`}></div>
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
              currentStep >= 2 ? 'bg-emerald-600 text-white' : 'bg-gray-200 text-gray-600'
            }`}>
              2
            </div>
          </div>
        </div>

        {/* Modal Content */}
        <div className="p-6">
          {currentStep === 1 && (
            <div className="space-y-6">
              <div>
                <h4 className="mb-4 text-lg font-medium text-gray-900">Select Mobile Money Provider</h4>
                <div className="grid grid-cols-2 gap-3">
                  {momoProviders.map((provider) => (
                    <button
                      key={provider.id}
                      onClick={() => setFormData({ ...formData, momoType: provider.id, providerName: provider.name })}
                      className={`p-4 rounded-xl border-2 transition-all ${
                        formData.momoType === provider.id
                          ? 'border-emerald-500 bg-emerald-50 shadow-md'
                          : 'border-gray-200 hover:border-gray-300 hover:shadow-sm'
                      }`}
                    >
                      <div className="text-center">
                        <div className="mb-2 text-2xl">{provider.icon}</div>
                        <p className="text-sm font-medium text-gray-900">{provider.name}</p>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}

          {currentStep === 2 && (
            <div className="space-y-6">
              <div>
                <h4 className="mb-4 text-lg font-medium text-gray-900">Enter Details</h4>
                <div className="space-y-4">
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-700">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      value={formData.phoneNumber}
                      onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
                      placeholder="+233 XX XXX XXXX"
                      className="px-4 py-3 w-full rounded-lg border border-gray-300 focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-700">
                      Wallet Name
                    </label>
                    <input
                      type="text"
                      value={formData.walletName}
                      onChange={(e) => setFormData({ ...formData, walletName: e.target.value })}
                      placeholder="e.g., My Personal Wallet, Business Account"
                      className="px-4 py-3 w-full rounded-lg border border-gray-300 focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                    />
                  </div>
                  <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
                    <p className="text-xs text-blue-700">
                      <strong>Note:</strong> Make sure this is the phone number registered with your {formData.providerName} account.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal Footer */}
          <div className="flex gap-3 mt-8">
            {currentStep === 2 && (
              <button
                onClick={onBack}
                className="flex flex-1 gap-2 justify-center items-center px-4 py-3 text-gray-700 bg-gray-100 rounded-lg transition-colors hover:bg-gray-200"
              >
                <ArrowLeft size={16} />
                Back
              </button>
            )}
            <button
              onClick={onNext}
              disabled={!formData.momoType || (currentStep === 2 && (!formData.phoneNumber || !formData.walletName))}
              className={`flex-1 px-4 py-3 text-white font-medium rounded-lg transition-colors ${
                !formData.momoType || (currentStep === 2 && (!formData.phoneNumber || !formData.walletName))
                  ? 'bg-gray-300 cursor-not-allowed'
                  : 'bg-emerald-600 hover:bg-emerald-700'
              }`}
            >
              {currentStep === 1 ? 'Next' : 'Continue'}
              <ArrowRight size={16} className="inline ml-2" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
